
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b0823", function(module, exports) {
'use strict';
var $8025ecd38d51d411$var$slice = Array.prototype.slice;

var $4C8be = parcelRequire("4C8be");
var $8025ecd38d51d411$var$origKeys = Object.keys;

var $8025ecd38d51d411$var$keysShim = $8025ecd38d51d411$var$origKeys ? function keys(o) {
    return $8025ecd38d51d411$var$origKeys(o);
} : (parcelRequire("dPAOG"));
var $8025ecd38d51d411$var$originalKeys = Object.keys;
$8025ecd38d51d411$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($4C8be(object)) return $8025ecd38d51d411$var$originalKeys($8025ecd38d51d411$var$slice.call(object));
            return $8025ecd38d51d411$var$originalKeys(object);
        };
    } else Object.keys = $8025ecd38d51d411$var$keysShim;
    return Object.keys || $8025ecd38d51d411$var$keysShim;
};
module.exports = $8025ecd38d51d411$var$keysShim;

});
parcelRegister("4C8be", function(module, exports) {
'use strict';
var $35c10e721c3c58a1$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $35c10e721c3c58a1$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $35c10e721c3c58a1$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("dPAOG", function(module, exports) {
'use strict';
var $a11c98c88d5ec803$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $a11c98c88d5ec803$var$has = Object.prototype.hasOwnProperty;
    var $a11c98c88d5ec803$var$toStr = Object.prototype.toString;
    var $a11c98c88d5ec803$var$isArgs = (parcelRequire("4C8be")); // eslint-disable-line global-require
    var $a11c98c88d5ec803$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $a11c98c88d5ec803$var$hasDontEnumBug = !$a11c98c88d5ec803$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $a11c98c88d5ec803$var$hasProtoEnumBug = $a11c98c88d5ec803$var$isEnumerable.call(function() {}, 'prototype');
    var $a11c98c88d5ec803$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $a11c98c88d5ec803$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $a11c98c88d5ec803$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $a11c98c88d5ec803$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$a11c98c88d5ec803$var$excludedKeys['$' + k] && $a11c98c88d5ec803$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $a11c98c88d5ec803$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $a11c98c88d5ec803$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$a11c98c88d5ec803$var$hasAutomationEqualityBug) return $a11c98c88d5ec803$var$equalsConstructorPrototype(o);
        try {
            return $a11c98c88d5ec803$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $a11c98c88d5ec803$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $a11c98c88d5ec803$var$toStr.call(object) === '[object Function]';
        var isArguments = $a11c98c88d5ec803$var$isArgs(object);
        var isString = isObject && $a11c98c88d5ec803$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $a11c98c88d5ec803$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$a11c98c88d5ec803$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $a11c98c88d5ec803$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($a11c98c88d5ec803$var$hasDontEnumBug) {
            var skipConstructor = $a11c98c88d5ec803$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $a11c98c88d5ec803$var$dontEnums.length; ++k)if (!(skipConstructor && $a11c98c88d5ec803$var$dontEnums[k] === 'constructor') && $a11c98c88d5ec803$var$has.call(object, $a11c98c88d5ec803$var$dontEnums[k])) theKeys.push($a11c98c88d5ec803$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $a11c98c88d5ec803$var$keysShim;

});


parcelRegister("55QXP", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $59f4a16af392a89e$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $59f4a16af392a89e$export$9cf3651d97128b9c);
var $59f4a16af392a89e$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $59f4a16af392a89e$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("6T83W", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $45f9d29983866387$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $2jjxD = parcelRequire("2jjxD");

var $4KS7f = parcelRequire("4KS7f");

var $aFUXX = parcelRequire("aFUXX");

var $1yB28 = parcelRequire("1yB28");

var $kOV42 = parcelRequire("kOV42");

var $3gadb = parcelRequire("3gadb");

var $7BTEV = parcelRequire("7BTEV");
const $45f9d29983866387$var$commentBadgeWrapper = (0, $3jLHL.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorUnitZIndex) * 10
});
const $45f9d29983866387$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $45f9d29983866387$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $45f9d29983866387$export$ef88b752358da42 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $gwFzn.useState)($45f9d29983866387$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $7BTEV.commentMessages).viewCommentsOnMedia);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($45f9d29983866387$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $gwFzn.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $45f9d29983866387$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $45f9d29983866387$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $45f9d29983866387$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4KS7f.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kOV42)))
        })
    })));
});

});
parcelRegister("7BTEV", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $724c8781ca7eb4e2$export$4c0d145df60cfb04);

var $2nPZH = parcelRequire("2nPZH");
const $724c8781ca7eb4e2$export$4c0d145df60cfb04 = (0, $2nPZH.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});

});


parcelRegister("fGYGE", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $4e0b21253fab8db4$export$d5da84b0136a0cc4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1yB28 = parcelRequire("1yB28");

var $kOV42 = parcelRequire("kOV42");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $7BTEV = parcelRequire("7BTEV");
const $4e0b21253fab8db4$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius'
});
const $4e0b21253fab8db4$var$mediumBadgeStyles = (0, $ecnYn.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $4e0b21253fab8db4$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $dBxQj.default)();
    const title = intl.formatMessage((0, $7BTEV.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $gwFzn.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            xcss: [
                $4e0b21253fab8db4$var$baseStyles,
                $4e0b21253fab8db4$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kOV42)))
            })
        })
    });
};

});

parcelRegister("4i54r", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $df07f356bbd706ec$export$66bf2ed7a5d4691f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lpHGz = parcelRequire("lpHGz");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $dztev = parcelRequire("dztev");
const $df07f356bbd706ec$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $df07f356bbd706ec$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $df07f356bbd706ec$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $dBxQj.default)();
    const message = intl.formatMessage((0, $dztev.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $df07f356bbd706ec$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        padding: "space.050",
        xcss: $df07f356bbd706ec$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpHGz))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("dztev", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $c4b5cf4ce6d702b4$export$8e36294abfabe45e);

var $2nPZH = parcelRequire("2nPZH");
const $c4b5cf4ce6d702b4$export$8e36294abfabe45e = (0, $2nPZH.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});

});


parcelRegister("1xbL9", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $0b276d94054df1c8$export$6a31fc38737d0e58);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $0b276d94054df1c8$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $0b276d94054df1c8$var$hackedZIndexStyles = (0, $ecnYn.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $0b276d94054df1c8$var$resizeOffsetStyles = (0, $ecnYn.xcss)({
    right: 'space.150'
});
const $0b276d94054df1c8$var$getBadgeVisible = (width, height)=>{
    return width && width < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $0b276d94054df1c8$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $gwFzn.useState)($0b276d94054df1c8$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $gwFzn.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($0b276d94054df1c8$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $0b276d94054df1c8$var$containerStyles,
            useMinimumZIndex && $0b276d94054df1c8$var$hackedZIndexStyles,
            extendedResizeOffset && $0b276d94054df1c8$var$resizeOffsetStyles
        ],
        children: children
    });
};

});

parcelRegister("eUDtA", function(module, exports) {

$parcel$export(module.exports, "Status", () => $fb06ceb36ba8e92b$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5nBzc = parcelRequire("5nBzc");

var $1DWH0 = parcelRequire("1DWH0");

var $hFf4D = parcelRequire("hFf4D");

var $aLypr = parcelRequire("aLypr");
function $fb06ceb36ba8e92b$var$_defineProperty(e, r, t) {
    return (r = $fb06ceb36ba8e92b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb06ceb36ba8e92b$var$_toPropertyKey(t) {
    var i = $fb06ceb36ba8e92b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb06ceb36ba8e92b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE = 'default';
const $fb06ceb36ba8e92b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $fb06ceb36ba8e92b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $fb06ceb36ba8e92b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $fb06ceb36ba8e92b$var$StatusInternal extends (0, $gwFzn.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap[color] || $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $7UHDa.jsx)("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $35pXk.default)([
                $fb06ceb36ba8e92b$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                appearance: appearance,
                maxWidth: $fb06ceb36ba8e92b$var$MAX_WIDTH,
                isBold: isBold,
                children: text
            })
        });
    }
    constructor(...args){
        super(...args);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "hoverStartTime", 0);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$fb06ceb36ba8e92b$var$_defineProperty($fb06ceb36ba8e92b$var$StatusInternal, "displayName", 'StatusInternal');
const $fb06ceb36ba8e92b$export$96e9906d6d93a972 = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($fb06ceb36ba8e92b$var$StatusInternal);

});
parcelRegister("hFf4D", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $d7337cb21e4187c0$export$aa98853957f9f5aa);
const $d7337cb21e4187c0$export$d821aa4c8afb384e = 'fabric-elements';
const $d7337cb21e4187c0$var$packageName = "platform-pkg";
const $d7337cb21e4187c0$var$packageVersion = "0.0.0-use.local";
const $d7337cb21e4187c0$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $d7337cb21e4187c0$var$packageName;
        statusPayload.attributes.packageVersion = $d7337cb21e4187c0$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($d7337cb21e4187c0$export$d821aa4c8afb384e);
        return event;
    };

});

parcelRegister("aLypr", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_HOVER_DELAY", () => $e5e607f963e2ce3b$export$7452d7062a4d0634);
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;

});


parcelRegister("jpMnG", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $f34f4663ccb261f9$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $4FhhO = parcelRequire("4FhhO");

var $hlhtG = parcelRequire("hlhtG");
var $js7oX = parcelRequire("js7oX");

var $inPa6 = parcelRequire("inPa6");

var $dehRH = parcelRequire("dehRH");
var $ihjDz = parcelRequire("ihjDz");

var $fO7zn = parcelRequire("fO7zn");

var $3rvSa = parcelRequire("3rvSa");

var $7NoXb = parcelRequire("7NoXb");

var $iu6m9 = parcelRequire("iu6m9");

var $cys8a = parcelRequire("cys8a");

var $5gVJx = parcelRequire("5gVJx");

var $gPGX6 = parcelRequire("gPGX6");

var $37aQC = parcelRequire("37aQC");

var $gNaJv = parcelRequire("gNaJv");

var $7WU7p = parcelRequire("7WU7p");
const $f34f4663ccb261f9$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $gwFzn.useState)();
    const [subscribeError, setSubscribeError] = (0, $gwFzn.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $gwFzn.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $gwFzn.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $hlhtG.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $dehRH.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $dehRH.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $cys8a.messages).failedToUpload : (0, $cys8a.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('metadata-fetch', new (0, $fO7zn.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gPGX6.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $gwFzn.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $gwFzn.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $5gVJx.referenceHeights)['h1']),
            height: (0, $5gVJx.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $gwFzn.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $gwFzn.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $gwFzn.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $gwFzn.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(/*#__PURE__*/ (0, $3jLHL.jsx)((0, $7NoXb.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $37aQC.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $f34f4663ccb261f9$export$fca833ae4278270f = (0, $js7oX.default)($f34f4663ccb261f9$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("dehRH", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $fc1f7121f2c54ee5$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $fc1f7121f2c54ee5$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $fc1f7121f2c54ee5$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $fc1f7121f2c54ee5$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $fc1f7121f2c54ee5$export$3bc90882cb04fda4);

var $bhuzI = parcelRequire("bhuzI");

var $ihjDz = parcelRequire("ihjDz");
const $fc1f7121f2c54ee5$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc1f7121f2c54ee5$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $bhuzI.extractErrorInfo)(error)
        }
    };
};
const $fc1f7121f2c54ee5$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc1f7121f2c54ee5$export$d66a74eca3334206 = (fileState, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc1f7121f2c54ee5$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc1f7121f2c54ee5$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc1f7121f2c54ee5$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4(fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("bhuzI", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $4e9e5bfba2b350c8$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $4e9e5bfba2b350c8$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $4e9e5bfba2b350c8$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $4e9e5bfba2b350c8$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $4e9e5bfba2b350c8$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $4e9e5bfba2b350c8$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $4e9e5bfba2b350c8$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $4e9e5bfba2b350c8$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $4e9e5bfba2b350c8$export$4d33ada3618f7626);

var $dIgeg = parcelRequire("dIgeg");

var $7bPHJ = parcelRequire("7bPHJ");
var $wA8SJ = parcelRequire("wA8SJ");

var $eWRwJ = parcelRequire("eWRwJ");
const $4e9e5bfba2b350c8$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $4e9e5bfba2b350c8$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $4e9e5bfba2b350c8$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $4e9e5bfba2b350c8$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $4e9e5bfba2b350c8$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4e9e5bfba2b350c8$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4e9e5bfba2b350c8$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $4e9e5bfba2b350c8$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $4e9e5bfba2b350c8$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4e9e5bfba2b350c8$export$4af9d71992e89714(error),
        error: $4e9e5bfba2b350c8$export$88c61dcad53762da(error),
        errorDetail: $4e9e5bfba2b350c8$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4e9e5bfba2b350c8$export$29aa614726672b2e(error)
    };
};
const $4e9e5bfba2b350c8$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $4e9e5bfba2b350c8$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $4e9e5bfba2b350c8$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $4e9e5bfba2b350c8$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $4e9e5bfba2b350c8$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL));
    }
}
const $4e9e5bfba2b350c8$export$4d33ada3618f7626 = (payload)=>{
    return (0, $eWRwJ.default)((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL))((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
};

});
parcelRegister("7bPHJ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_MEDIA_CHANNEL", () => $f5d20cba8da3e43a$export$ec1779cb96554e1);
const $f5d20cba8da3e43a$export$ec1779cb96554e1 = 'media';

});

parcelRegister("wA8SJ", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $19999d8625134b0f$export$e24d38cbdf73bc1a);

var $cZs6j = parcelRequire("cZs6j");

var $g7NcR = parcelRequire("g7NcR");
const $19999d8625134b0f$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($cZs6j)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $19999d8625134b0f$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $19999d8625134b0f$export$e24d38cbdf73bc1a = (payload)=>$19999d8625134b0f$var$hasFileAttributesWithFileId(payload) ? (0, $g7NcR.produce)(payload, $19999d8625134b0f$var$sanitiseFileId) : payload;

});


parcelRegister("ihjDz", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $197aaa08f701d50c$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $197aaa08f701d50c$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $197aaa08f701d50c$export$11f9f5835c5b9a04);
class $197aaa08f701d50c$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $197aaa08f701d50c$export$2c035820a31723e extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$10ab445310d30114 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$18e89b7e50818288 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $197aaa08f701d50c$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $197aaa08f701d50c$export$d0a45ab59b4606b extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(source){
        super($197aaa08f701d50c$export$921ab4548acefaa4(source));
    }
}
function $197aaa08f701d50c$export$36b43e3dd9a92(err) {
    return err instanceof $197aaa08f701d50c$export$ec8d022824f41295;
}
const $197aaa08f701d50c$export$b380593ba3516c6f = (err)=>err instanceof $197aaa08f701d50c$export$2c035820a31723e;
const $197aaa08f701d50c$export$e1d87830b3784f94 = (err)=>err instanceof $197aaa08f701d50c$export$10ab445310d30114;
const $197aaa08f701d50c$export$443aeb298d35d79d = (err)=>$197aaa08f701d50c$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $197aaa08f701d50c$export$f00bb5a138da22e1(err) {
    return err instanceof $197aaa08f701d50c$export$d0a45ab59b4606b;
}
const $197aaa08f701d50c$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($197aaa08f701d50c$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error);
};
const $197aaa08f701d50c$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});


parcelRegister("7NoXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fs5Wi = parcelRequire("fs5Wi");

var $1GQGM = parcelRequire("1GQGM");

const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8TViC")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GQGM.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("fs5Wi", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $379228055afe24f5$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $379228055afe24f5$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $70BxX = parcelRequire("70BxX");

var $cOrQJ = parcelRequire("cOrQJ");
const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;

});
parcelRegister("70BxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2ec0906c10b2d9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3ypk1 = parcelRequire("3ypk1");

var $9DX83 = parcelRequire("9DX83");

var $dh538 = parcelRequire("dh538");
const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9DX83.default), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3ypk1.default), {
        ...props
    });
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;

});
parcelRegister("3ypk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc57da5733c6380$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dTk3A = parcelRequire("dTk3A");

var $9hlns = parcelRequire("9hlns");

var $gwrgp = parcelRequire("gwrgp");
const $1cc57da5733c6380$var$overlayZindex = (0, $dTk3A.layers).modal() + 10;
const $1cc57da5733c6380$export$5b927fc1ef8c468b = (0, $gwrgp.default)("div", {
    target: "e1if7vbe0"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $1cc57da5733c6380$var$overlayZindex
});
$1cc57da5733c6380$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $1cc57da5733c6380$export$52b4dfd89a6b3a1b = (0, $gwrgp.default)("div", {
    target: "e1if7vbe1"
})({
    name: "3hcm5q",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"
});
$1cc57da5733c6380$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $1cc57da5733c6380$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1cc57da5733c6380$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $7UHDa.jsx)($1cc57da5733c6380$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $1cc57da5733c6380$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($1cc57da5733c6380$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                size: "large",
                appearance: invertSpinnerColor || $1cc57da5733c6380$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("9DX83", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9hlns = parcelRequire("9hlns");
const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $35pXk.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                size: "large",
                appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("1GQGM", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $86b842c4b2e17806$export$51aee4c01b17acde);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $caX7N = parcelRequire("caX7N");
const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("8TViC", function(module, exports) {

let $01ac20a62683900c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $01ac20a62683900c$var$load("hTb1M"),
    $01ac20a62683900c$var$load("jkTol"),
    $01ac20a62683900c$var$load("bZxqd"),
    $01ac20a62683900c$var$load("6gqpV"),
    $01ac20a62683900c$var$load("4SIAe"),
    $01ac20a62683900c$var$load("doomh"),
    $01ac20a62683900c$var$load("4uhcp"),
    $01ac20a62683900c$var$load("gFHfi"),
    $01ac20a62683900c$var$load("1ff0G"),
    $01ac20a62683900c$var$load("1qUWs"),
    $01ac20a62683900c$var$load("eAnbE"),
    $01ac20a62683900c$var$load("dil5i"),
    $01ac20a62683900c$var$load("2fk6g"),
    $01ac20a62683900c$var$load("hPalR"),
    $01ac20a62683900c$var$load("8059b"),
    $01ac20a62683900c$var$load("fe4be"),
    $01ac20a62683900c$var$load("jDjSj"),
    $01ac20a62683900c$var$load("aZinD"),
    $01ac20a62683900c$var$load("ffEVr"),
    $01ac20a62683900c$var$load("joJy8"),
    $01ac20a62683900c$var$load("aHE9G"),
    $01ac20a62683900c$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("cys8a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d94a223ed3433d0e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $d94a223ed3433d0e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    unableToLoadContent: {
        id: "fabric.editor.unableToLoadContent",
        defaultMessage: "We couldn't load this content"
    },
    failedToUpload: {
        id: "fabric.editor.failed_to_upload",
        defaultMessage: "Failed to upload"
    }
});

});

parcelRegister("gPGX6", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $c12bc8babb02df83$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $fCrf0 = parcelRequire("fCrf0");

var $k0QVR = parcelRequire("k0QVR");

var $aWYXa = parcelRequire("aWYXa");

var $7WU7p = parcelRequire("7WU7p");
const $c12bc8babb02df83$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $gwFzn.useMemo)(()=>({
            traceId: (0, $fCrf0.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aWYXa.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $3jLHL.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("aWYXa", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $e496909ca63f7b47$export$1f97dc1e9d072692);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $gxsT9 = parcelRequire("gxsT9");

var $cbc8g = parcelRequire("cbc8g");

var $2wyC2 = parcelRequire("2wyC2");

var $21oLb = parcelRequire("21oLb");

var $10PJn = parcelRequire("10PJn");
const $e496909ca63f7b47$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $gwFzn.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $gwFzn.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $gwFzn.useState)(false);
    const imgRef = (0, $gwFzn.useRef)(null);
    const imageRef = (0, $gwFzn.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $10PJn.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $21oLb.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $21oLb.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            (0, $dh538.fg)('platform_media_add_ufo_custom_data') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cbc8g.default), {
                data: {
                    hasMediaComponent: true
                }
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2wyC2.ImageComponent), {
                loading: loading,
                "data-testid": "media-image",
                "data-vc": "media-image",
                draggable: false,
                alt: alt,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onLoad: imageLoadHandler,
                onError: onImageError,
                imageRef: mergedRef,
                src: dataURI,
                crossOrigin: crossOrigin,
                ...(0, $dh538.fg)('platform_exclude_media_offender_from_vc') && (0, $gxsT9.VcMediaWrapperProps)
            })
        ]
    });
});

});
parcelRegister("2wyC2", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $a49532cd1c66edc2$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $a49532cd1c66edc2$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $a49532cd1c66edc2$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$a49532cd1c66edc2$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("7WU7p", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $9hlns = parcelRequire("9hlns");

var $88T0B = parcelRequire("88T0B");

var $2UgCw = parcelRequire("2UgCw");
const $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $88T0B.ICON_SIZE_THRESOLD) })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2UgCw.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9hlns.default), {
        size: height > (0, $88T0B.ICON_SIZE_THRESOLD) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
parcelRegister("88T0B", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE_THRESOLD", () => $6a98a0a47ebe23af$export$88e3664eef60c981);
/** Height threshold that determines icon size to be small or medium */ const $6a98a0a47ebe23af$export$88e3664eef60c981 = 24;

});

parcelRegister("2UgCw", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $365414ee34d9fe7e$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $9CJBf = parcelRequire("9CJBf");
const $365414ee34d9fe7e$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $9CJBf.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("9CJBf", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $0090dcbf00152f3e$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $0090dcbf00152f3e$export$c4d4f06a25de97f = (0, $3jLHL.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("37aQC", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $7cf4b05323c49fee$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $bSKDV = parcelRequire("bSKDV");

var $fhm10 = parcelRequire("fhm10");
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $7cf4b05323c49fee$var$sizeWrapperStyle = (0, $3jLHL.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%'
});
const $7cf4b05323c49fee$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $fhm10.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $fhm10.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $bSKDV.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $fhm10.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $fhm10.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $fhm10.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $fhm10.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $7cf4b05323c49fee$var$sizeWrapperStyle
    }, children)));
};

});
parcelRegister("bSKDV", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $d1a10455ac2f8edd$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $d1a10455ac2f8edd$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $d1a10455ac2f8edd$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $d1a10455ac2f8edd$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});


parcelRegister("gNaJv", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $d55d56648ffb705b$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $6hqEj = parcelRequire("6hqEj");

var $3gadb = parcelRequire("3gadb");

var $88T0B = parcelRequire("88T0B");

var $2UgCw = parcelRequire("2UgCw");

var $cUGgR = parcelRequire("cUGgR");
const $d55d56648ffb705b$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $88T0B.ICON_SIZE_THRESOLD) })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2UgCw.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cUGgR.IconWrapper), null, icon || /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))), {
        label: "error",
        LEGACY_size: height > (0, $88T0B.ICON_SIZE_THRESOLD) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("cUGgR", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $6ea526080872ea45$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $6ea526080872ea45$var$wrapperStyle = (0, $3jLHL.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'span > svg': {
        verticalAlign: 'top'
    }
});
const $6ea526080872ea45$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $6ea526080872ea45$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("i4o81", function(module, exports) {

$parcel$export(module.exports, "default", () => $a406840fbc805bb1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kZmsK = parcelRequire("kZmsK");

var $bYRk6 = parcelRequire("bYRk6");



class $a406840fbc805bb1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("0yA6J")),
                (parcelRequire("bxlKR")),
                (parcelRequire("drGyB"))
            ]);
            $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kZmsK.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}
$a406840fbc805bb1$export$2e2bcd8739ae039.displayName = 'MediaInlineCardLoader';
$a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = void 0;
$a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = void 0;

});
parcelRegister("kZmsK", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $1a4a0b48836516fc$export$4449fcbb2ad61ad1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $Dmhrr = parcelRequire("Dmhrr");

var $9hlns = parcelRequire("9hlns");

var $d3MnB = parcelRequire("d3MnB");

var $lyeFC = parcelRequire("lyeFC");

var $9HuAe = parcelRequire("9HuAe");
class $1a4a0b48836516fc$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9HuAe.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lyeFC.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d3MnB.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lyeFC.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("Dmhrr", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $81345eb3da367d71$export$b89a827e9254211a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $f32vE = parcelRequire("f32vE");
class $81345eb3da367d71$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f32vE.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("f32vE", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $f4d2cc17db8a2086$export$e6dfd72ab29f8598);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7qw0L = parcelRequire("7qw0L");

var $7ThrQ = parcelRequire("7ThrQ");

var $dh538 = parcelRequire("dh538");
const $f4d2cc17db8a2086$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7ThrQ.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7qw0L.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("7qw0L", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $93e87b57966b1260$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $93e87b57966b1260$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $6fnsQ.B300)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $93e87b57966b1260$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $93e87b57966b1260$var$selected;
    else return 'user-select: text';
};
const $93e87b57966b1260$export$e6dfd72ab29f8598 = (0, $gwrgp.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$93e87b57966b1260$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N40A)})`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isError && {
        backgroundColor: `var(--ds-background-danger, ${0, $6fnsQ.R50})`,
        cursor: 'default',
        '&:hover': {
            backgroundColor: `var(--ds-background-danger, ${0, $6fnsQ.R50})`
        }
    });

});

parcelRegister("7ThrQ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $c18bd19407527c2b$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $c18bd19407527c2b$var$selectedStyles = null;
const $c18bd19407527c2b$var$notSelectedStyles = null;
const $c18bd19407527c2b$var$errorStyles = null;
const $c18bd19407527c2b$var$wrapperStyles = null; /*
                              Media Inline cards should have the following layout:
                              -----------------
                              | icon | title |
                              -----------------
                              The aim is to ensure (1) all children are
                              in line with each other, (2) are vertically
                              centered.
                            */ 
const $c18bd19407527c2b$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, isError: isError, children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $35pXk.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syaz1fxt _bfhkm7j4 _1rkwglyw _80omtlke _irr315ej",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs666x _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhk1gly _80om73ad _irr31gly"
        ]),
        children: children
    });

});



parcelRegister("d3MnB", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $cf4ec8e3d957b355$export$d34be4d513116847);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fp8VN = parcelRequire("fp8VN");

var $3iiat = parcelRequire("3iiat");

var $9HuAe = parcelRequire("9HuAe");

var $8Q3VW = parcelRequire("8Q3VW");
class $cf4ec8e3d957b355$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fp8VN))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3iiat.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9HuAe.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("3iiat", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $85360ec6e10e0eb4$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $85360ec6e10e0eb4$export$a201b065fc2e76a1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kDc8H = parcelRequire("kDc8H");

var $kGQvC = parcelRequire("kGQvC");

var $dh538 = parcelRequire("dh538");
const $85360ec6e10e0eb4$export$f04a61298a47a40f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kGQvC.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDc8H.Icon), {
        ...props
    });
const $85360ec6e10e0eb4$export$a201b065fc2e76a1 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kGQvC.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDc8H.AKIconWrapper), {
        ...props
    });

});
parcelRegister("kDc8H", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $26e5494a2f4757d2$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $26e5494a2f4757d2$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $26e5494a2f4757d2$export$f04a61298a47a40f = (0, $gwrgp.default)("img", {
    target: "ebf58rv0"
})({
    name: "ijlt3r",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"
});
$26e5494a2f4757d2$export$f04a61298a47a40f.defaultProps = {
    alt: 'icon'
};
const $26e5494a2f4757d2$export$a201b065fc2e76a1 = (0, $gwrgp.default)("span", {
    target: "ebf58rv1"
})({
    name: "12aho5i",
    styles: "margin-right:var(--ds-space-negative-025, -2px);"
});

});

parcelRegister("kGQvC", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $5112814eaaf490cd$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $5112814eaaf490cd$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $5112814eaaf490cd$var$iconStyles = null;
const $5112814eaaf490cd$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $35pXk.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }); // Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $5112814eaaf490cd$var$akIconWrapperStyles = null;
const $5112814eaaf490cd$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("9HuAe", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $40f11cd2f33df153$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $40f11cd2f33df153$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $40f11cd2f33df153$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $40f11cd2f33df153$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $40f11cd2f33df153$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $40f11cd2f33df153$export$ddce81e032b0736e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2LKDa = parcelRequire("2LKDa");

var $fX8We = parcelRequire("fX8We");

var $dh538 = parcelRequire("dh538");
const $40f11cd2f33df153$export$be58b4326e23250f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$e31a6cc0a4c97f0e = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.EmojiWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$c73a53738ef9e3f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconTitleWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$75180efdd3f4d9c2 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.LozengeWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$a16269f205a2f280 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.LozengeBlockWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$91b164375b8037b5 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.RightIconPositionWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$7291f9f954790243 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconPositionWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$ddce81e032b0736e = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("2LKDa", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d460a69b4d3843b5$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $d460a69b4d3843b5$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $d460a69b4d3843b5$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $d460a69b4d3843b5$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $d460a69b4d3843b5$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $d460a69b4d3843b5$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $d460a69b4d3843b5$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $d460a69b4d3843b5$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $gwrgp = parcelRequire("gwrgp");
const $d460a69b4d3843b5$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d460a69b4d3843b5$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d460a69b4d3843b5$export$be58b4326e23250f = (0, $gwrgp.default)("span", {
    target: "ec5pts50"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$b993aa7bab57be12);
const $d460a69b4d3843b5$export$e31a6cc0a4c97f0e = (0, $gwrgp.default)("span", {
    target: "ec5pts51"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$b993aa7bab57be12);
const $d460a69b4d3843b5$export$c73a53738ef9e3f = (0, $gwrgp.default)("span", {
    target: "ec5pts52"
})({
    name: "1p7ax5",
    styles: "white-space:pre-wrap;word-break:break-all;"
});
const $d460a69b4d3843b5$export$75180efdd3f4d9c2 = (0, $gwrgp.default)("span", {
    target: "ec5pts53"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $d460a69b4d3843b5$export$a16269f205a2f280 = (0, $gwrgp.default)("span", {
    target: "ec5pts54"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $d460a69b4d3843b5$export$91b164375b8037b5 = (0, $gwrgp.default)("span", {
    target: "ec5pts55"
})({
    name: "15325vn",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block;"
});
const $d460a69b4d3843b5$export$7291f9f954790243 = (0, $gwrgp.default)("span", {
    target: "ec5pts56"
})({
    name: "1lcr4h8",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block;"
});
const $d460a69b4d3843b5$export$ddce81e032b0736e = (0, $gwrgp.default)("span", {
    target: "ec5pts57"
})({
    name: "klch0j",
    styles: "width:14px;height:100%;display:inline-block;opacity:0;"
});

});

parcelRegister("fX8We", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $fd9b070c354e8c1f$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fd9b070c354e8c1f$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fd9b070c354e8c1f$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $fd9b070c354e8c1f$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fd9b070c354e8c1f$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fd9b070c354e8c1f$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fd9b070c354e8c1f$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $fd9b070c354e8c1f$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $fd9b070c354e8c1f$var$iconOverrideStyles = null;
const $fd9b070c354e8c1f$var$iconWrapperStyles = null; // Wraps all icons represented in Inline Links. Icons have three sources/types:
const $fd9b070c354e8c1f$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$emojiWrapperStyles = null; // Wraps all emoji in Inline Links similar to icon
const $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconTitleWrapperStyles = null; // The main 'wrapping' element, title of the content.
const $fd9b070c354e8c1f$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$lozengeWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$lozengeBlockWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$rightIconPositionWrapperStyles = null;
const $fd9b070c354e8c1f$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconPositionWrapperStyles = null; // The following components are used to absolutely position icons in the vertical center.
const $fd9b070c354e8c1f$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconEmptyWrapperStyles = null;
const $fd9b070c354e8c1f$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("lyeFC", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $d812b1a99afbef93$export$52b4dfd89a6b3a1b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eeDwq = parcelRequire("eeDwq");

var $3VTkZ = parcelRequire("3VTkZ");

var $dh538 = parcelRequire("dh538");
const $d812b1a99afbef93$export$52b4dfd89a6b3a1b = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3VTkZ.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eeDwq.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("eeDwq", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $742f0deb19d1e22c$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2LKDa = parcelRequire("2LKDa");

var $gwrgp = parcelRequire("gwrgp");
const $742f0deb19d1e22c$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $gwrgp.default)((0, $2LKDa.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "wbojq2",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px);"
});

});

parcelRegister("3VTkZ", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $8f39e15e200c8aa2$var$spinnerWrapperStyles = null;
const $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("0yA6J", function(module, exports) {

let $001ad3580449fc02$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $001ad3580449fc02$var$load("hTb1M"),
    $001ad3580449fc02$var$load("02UZz"),
    $001ad3580449fc02$var$load("jkTol"),
    $001ad3580449fc02$var$load("kIjBt"),
    $001ad3580449fc02$var$load("4SIAe"),
    $001ad3580449fc02$var$load("eqSsW"),
    $001ad3580449fc02$var$load("aZinD"),
    $001ad3580449fc02$var$load("7VwsU"),
    $001ad3580449fc02$var$load("fsZ6i"),
    $001ad3580449fc02$var$load("eAnbE"),
    $001ad3580449fc02$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("bxlKR", function(module, exports) {

let $8663a6d94c76b698$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8663a6d94c76b698$var$load("hTb1M"),
    $8663a6d94c76b698$var$load("jkTol"),
    $8663a6d94c76b698$var$load("bZxqd"),
    $8663a6d94c76b698$var$load("45SdR"),
    $8663a6d94c76b698$var$load("joJy8"),
    $8663a6d94c76b698$var$load("aHE9G"),
    $8663a6d94c76b698$var$load("dil5i"),
    $8663a6d94c76b698$var$load("2fk6g"),
    $8663a6d94c76b698$var$load("hPalR"),
    $8663a6d94c76b698$var$load("8059b"),
    $8663a6d94c76b698$var$load("fe4be"),
    $8663a6d94c76b698$var$load("jDjSj"),
    $8663a6d94c76b698$var$load("4M7W5")
]).then(()=>parcelRequire('akEZB'));

});

parcelRegister("drGyB", function(module, exports) {

let $9c9eceeb3bc809c1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9c9eceeb3bc809c1$var$load("iP5Bv").then(()=>parcelRequire('lysJr'));

});


parcelRegister("1BiXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f66d7816a46cebf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $9s7Po = parcelRequire("9s7Po");

var $hnvzE = parcelRequire("hnvzE");
const $2f66d7816a46cebf$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
const $2f66d7816a46cebf$var$CardLoadingWithContext = ()=>{
    const props = (0, $gwFzn.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9s7Po.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $2f66d7816a46cebf$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "jrCIr",
    name: "MediaCardWithMediaClientProvider",
    loader: ()=>(parcelRequire("7KDUR")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($2f66d7816a46cebf$var$CardLoadingWithContext, {})
});
const $2f66d7816a46cebf$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($2f66d7816a46cebf$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($2f66d7816a46cebf$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$2f66d7816a46cebf$var$CardLoader.preload = ()=>$2f66d7816a46cebf$var$MediaCardWithMediaClientProvider.preload();
var $2f66d7816a46cebf$export$2e2bcd8739ae039 = $2f66d7816a46cebf$var$CardLoader;

});
parcelRegister("9s7Po", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $bf3fa0f5391f39b8$export$5d25853fd6bdf402);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fDGbV = parcelRequire("fDGbV");

var $64ehG = parcelRequire("64ehG");

var $9hlns = parcelRequire("9hlns");
class $bf3fa0f5391f39b8$export$5d25853fd6bdf402 extends (0, $gwFzn.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $64ehG.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("64ehG", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $fd9c20c94dd40490$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $1CyYH = parcelRequire("1CyYH");
const $fd9c20c94dd40490$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $1CyYH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("1CyYH", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $aedc46c8c12477c6$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $fN2NR = parcelRequire("fN2NR");

var $6fnsQ = parcelRequire("6fnsQ");
const $aedc46c8c12477c6$export$491e6397d7c1480b = ({ dimensions: dimensions })=>(0, $3jLHL.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
        color: `var(--ds-icon, ${(0, $6fnsQ.N50)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("fN2NR", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $adbace133e9e6202$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $adbace133e9e6202$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $adbace133e9e6202$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $adbace133e9e6202$export$7a57f79000377ca2);

var $dTk3A = parcelRequire("dTk3A");
const $adbace133e9e6202$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $adbace133e9e6202$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $adbace133e9e6202$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $adbace133e9e6202$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $adbace133e9e6202$export$7a57f79000377ca2 = `
  border-radius: ${(0, $dTk3A.borderRadius)()}px;
`;
const $adbace133e9e6202$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $dTk3A.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $dTk3A.borderRadius)()}px;
`;
const $adbace133e9e6202$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("7KDUR", function(module, exports) {

let $5a4bcac7fc6c767b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5a4bcac7fc6c767b$var$load("02UZz"),
    $5a4bcac7fc6c767b$var$load("jkTol"),
    $5a4bcac7fc6c767b$var$load("bZxqd"),
    $5a4bcac7fc6c767b$var$load("45SdR"),
    $5a4bcac7fc6c767b$var$load("6gqpV"),
    $5a4bcac7fc6c767b$var$load("cf51e"),
    $5a4bcac7fc6c767b$var$load("lHceO"),
    $5a4bcac7fc6c767b$var$load("hTb1M"),
    $5a4bcac7fc6c767b$var$load("e53Dv"),
    $5a4bcac7fc6c767b$var$load("aZinD"),
    $5a4bcac7fc6c767b$var$load("eAnbE"),
    $5a4bcac7fc6c767b$var$load("c6MKV"),
    $5a4bcac7fc6c767b$var$load("hzK1f"),
    $5a4bcac7fc6c767b$var$load("fqrMn"),
    $5a4bcac7fc6c767b$var$load("fYi1a"),
    $5a4bcac7fc6c767b$var$load("bjzRn"),
    $5a4bcac7fc6c767b$var$load("8mzoy"),
    $5a4bcac7fc6c767b$var$load("7a9CL"),
    $5a4bcac7fc6c767b$var$load("ivQYH"),
    $5a4bcac7fc6c767b$var$load("8pE8S"),
    $5a4bcac7fc6c767b$var$load("9Bu2S"),
    $5a4bcac7fc6c767b$var$load("42vdC"),
    $5a4bcac7fc6c767b$var$load("P5iE2"),
    $5a4bcac7fc6c767b$var$load("dil5i"),
    $5a4bcac7fc6c767b$var$load("2fk6g"),
    $5a4bcac7fc6c767b$var$load("ffEVr"),
    $5a4bcac7fc6c767b$var$load("8LPnw"),
    $5a4bcac7fc6c767b$var$load("hPalR"),
    $5a4bcac7fc6c767b$var$load("6ACCg"),
    $5a4bcac7fc6c767b$var$load("8059b"),
    $5a4bcac7fc6c767b$var$load("kIjBt"),
    $5a4bcac7fc6c767b$var$load("fe4be"),
    $5a4bcac7fc6c767b$var$load("jDjSj"),
    $5a4bcac7fc6c767b$var$load("8DoxJ"),
    $5a4bcac7fc6c767b$var$load("joJy8"),
    $5a4bcac7fc6c767b$var$load("aHE9G"),
    $5a4bcac7fc6c767b$var$load("fwuXj")
]).then(()=>parcelRequire('r0CCR'));

});


parcelRegister("3BZZG", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $b77837f445efd10f$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $b77837f445efd10f$export$ed7b8a4728e9c63);
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};

});

parcelRegister("8QL6C", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $586e61da7604bdbd$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $586e61da7604bdbd$export$383e8f51978266d);

var $6mxnm = parcelRequire("6mxnm");

var $hMBjV = parcelRequire("hMBjV");

var $78fzv = parcelRequire("78fzv");
const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}

});
parcelRegister("6mxnm", function(module, exports) {

$parcel$export(module.exports, "supportedProducts", () => $6b97f3fad80b5910$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});

parcelRegister("hMBjV", function(module, exports) {

$parcel$export(module.exports, "getProductKeys", () => $d17c6572fbd16cff$export$189fe120be7e73fc);
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;

});

parcelRegister("78fzv", function(module, exports) {

$parcel$export(module.exports, "getGenericFeatureFlag", () => $18475707c4faede4$export$f2687d0de19e4973);

var $bcpPc = parcelRequire("bcpPc");
function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("bcpPc", function(module, exports) {

$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $6c56cea62b261d1c$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});



parcelRegister("e63NX", function(module, exports) {

$parcel$export(module.exports, "isFileIdentifier", () => $aeded572d33c89ca$export$7695387cd66cf5b5);
$parcel$export(module.exports, "isExternalImageIdentifier", () => $aeded572d33c89ca$export$2782f2fbff82f0c9);

var $aAuSn = parcelRequire("aAuSn");
const $aeded572d33c89ca$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $aeded572d33c89ca$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $aeded572d33c89ca$export$5883721593c4e4b1 = (a, b)=>{
    if ($aeded572d33c89ca$export$7695387cd66cf5b5(a) && $aeded572d33c89ca$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($aAuSn)))(a, b);
};

});
parcelRegister("aAuSn", function(module, exports) {
var $7b5537848be1aadf$var$pSlice = Array.prototype.slice;

var $ghDpO = parcelRequire("ghDpO");

var $b43aO = parcelRequire("b43aO");
var $7b5537848be1aadf$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $7b5537848be1aadf$var$objEquiv(actual, expected, opts);
};
function $7b5537848be1aadf$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $7b5537848be1aadf$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $7b5537848be1aadf$var$objEquiv(a, b, opts) {
    var i, key;
    if ($7b5537848be1aadf$var$isUndefinedOrNull(a) || $7b5537848be1aadf$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($b43aO(a)) {
        if (!$b43aO(b)) return false;
        a = $7b5537848be1aadf$var$pSlice.call(a);
        b = $7b5537848be1aadf$var$pSlice.call(b);
        return $7b5537848be1aadf$var$deepEqual(a, b, opts);
    }
    if ($7b5537848be1aadf$var$isBuffer(a)) {
        if (!$7b5537848be1aadf$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $ghDpO(a), kb = $ghDpO(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$7b5537848be1aadf$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});
parcelRegister("ghDpO", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("b43aO", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});



parcelRegister("31QJ7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $51c490bf07ac8c08$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $51c490bf07ac8c08$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    video_settings: {
        id: "fabric.media.video_settings",
        defaultMessage: "Video Settings"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    }
});

});

parcelRegister("aL0VQ", function(module, exports) {

$parcel$export(module.exports, "useFileHashes", () => $4cae511015088d55$export$f91c9e51e5ab027d);

var $gwFzn = parcelRequire("gwFzn");

var $hZ6O7 = parcelRequire("hZ6O7");

var $jRNsq = parcelRequire("jRNsq");

var $i2CQL = parcelRequire("i2CQL");

var $jQCJ9 = parcelRequire("jQCJ9");
const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $gwFzn.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $gwFzn.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $gwFzn.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $gwFzn.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}

});
parcelRegister("jQCJ9", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $8227eceacc56cecd$export$5cae361ad82dce8b);

var $gwFzn = parcelRequire("gwFzn");
function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("46EIy", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $340ce807e864e408$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $340ce807e864e408$export$817db220b90d8024);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $26gV0 = parcelRequire("26gV0");

var $6ZDLj = parcelRequire("6ZDLj");
const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId,
            children: [
                this.renderLeftArrow(),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ZDLj.FilmStripListWrapper), {
                    ref: this.handleWindowElementChange,
                    onWheel: this.handleScroll,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    "data-testid": "filmstrip-list-wrapper",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ZDLj.FilmStripList), {
                        ref: this.handleBufferElementChange,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            transform: transform,
                            transitionProperty: transitionProperty,
                            transitionDuration: transitionDuration
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode)
                    })
                }),
                this.renderRightArrow()
            ]
        });
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($26gV0)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ZDLj.FilmStripListItem), {
        index: key,
        children: child
    }, key);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("6ZDLj", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $15c7f4a4aa94e52b$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $15c7f4a4aa94e52b$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $15c7f4a4aa94e52b$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $15c7f4a4aa94e52b$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $15c7f4a4aa94e52b$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $15c7f4a4aa94e52b$export$54cfc70c184c0713);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $4cVjq = parcelRequire("4cVjq");

var $bwcZT = parcelRequire("bwcZT");
const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.ArrowLeftWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.ArrowLeftWrapper), {
        ...props
    });
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.ShadowRight), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.ShadowRight), {
        ...props
    });
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.ArrowRightWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.ArrowRightWrapper), {
        ...props
    });
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.LeftArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.LeftArrow), {
        ...props
    });
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.RightArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.RightArrow), {
        ...props
    });
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.FilmStripViewWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.FilmStripViewWrapper), {
        ...props
    });
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwcZT.FilmStripListItem), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4cVjq.FilmStripListItem), {
        ...props
    });

});
parcelRegister("4cVjq", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $cf775ce3ed09dcbf$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $cf775ce3ed09dcbf$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $cf775ce3ed09dcbf$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $cf775ce3ed09dcbf$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $cf775ce3ed09dcbf$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $cf775ce3ed09dcbf$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $cf775ce3ed09dcbf$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $cf775ce3ed09dcbf$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $cf775ce3ed09dcbf$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $3bV1Q = parcelRequire("3bV1Q");

var $4HvFx = parcelRequire("4HvFx");

var $46EIy = parcelRequire("46EIy");

var $6fnsQ = parcelRequire("6fnsQ");
const $cf775ce3ed09dcbf$var$filmStripViewStyles = (0, $3jLHL.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $cf775ce3ed09dcbf$var$filmStripListWrapperStyles = (0, $3jLHL.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $cf775ce3ed09dcbf$var$filmStripListStyles = (0, $3jLHL.css)({
    margin: 0,
    padding: 0,
    transitionProperty: 'transform',
    transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
    whiteSpace: 'nowrap',
    display: 'inline-block'
});
const $cf775ce3ed09dcbf$var$filmStripListItemStyles = (0, $3jLHL.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0
});
const $cf775ce3ed09dcbf$var$arrowWrapperStyles = (0, $3jLHL.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $6fnsQ.N20)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $6fnsQ.N40)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $6fnsQ.B50)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cf775ce3ed09dcbf$var$arrowLeftWrapperStyles = (0, $3jLHL.css)($cf775ce3ed09dcbf$var$arrowWrapperStyles, {
    left: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        paddingRight: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cf775ce3ed09dcbf$var$arrowRightWrapperStyles = (0, $3jLHL.css)($cf775ce3ed09dcbf$var$arrowWrapperStyles, {
    right: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $cf775ce3ed09dcbf$var$shadowStyles = (0, $3jLHL.css)({
    position: 'absolute',
    zIndex: 10,
    height: '100%',
    top: 0,
    width: '2px',
    backgroundColor: "var(--ds-border, rgba(0, 0, 0, 0.2))"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cf775ce3ed09dcbf$var$shadowLeftStyles = (0, $3jLHL.css)($cf775ce3ed09dcbf$var$shadowStyles, {
    left: 0
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cf775ce3ed09dcbf$var$shadowRightStyles = (0, $3jLHL.css)($cf775ce3ed09dcbf$var$shadowStyles, {
    right: 0
});
const $cf775ce3ed09dcbf$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$shadowLeftStyles
    }, children);
const $cf775ce3ed09dcbf$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $cf775ce3ed09dcbf$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$shadowRightStyles
    }, children);
const $cf775ce3ed09dcbf$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $cf775ce3ed09dcbf$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $3jLHL.jsx)($cf775ce3ed09dcbf$var$ShadowLeft, null, /*#__PURE__*/ (0, $3jLHL.jsx)($cf775ce3ed09dcbf$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $cf775ce3ed09dcbf$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $3jLHL.jsx)($cf775ce3ed09dcbf$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $3jLHL.jsx)($cf775ce3ed09dcbf$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HvFx))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $cf775ce3ed09dcbf$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $cf775ce3ed09dcbf$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $cf775ce3ed09dcbf$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $cf775ce3ed09dcbf$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $3jLHL.jsx)("ul", {
        css: $cf775ce3ed09dcbf$var$filmStripListStyles,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $cf775ce3ed09dcbf$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $3jLHL.jsx)("li", {
        css: $cf775ce3ed09dcbf$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $46EIy.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});

parcelRegister("bwcZT", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $1156f5d5007639c5$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $1156f5d5007639c5$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $1156f5d5007639c5$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $1156f5d5007639c5$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $1156f5d5007639c5$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $1156f5d5007639c5$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $1156f5d5007639c5$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $1156f5d5007639c5$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $1156f5d5007639c5$export$54cfc70c184c0713);
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $3bV1Q = parcelRequire("3bV1Q");

var $4HvFx = parcelRequire("4HvFx");

var $46EIy = parcelRequire("46EIy");
const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkmuej",
            "_1ltvidpf"
        ]),
        children: children
    });
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs1cd0 _syazwdcn _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l31gjq _irr316qz _9h8haqb7 _1di6fg4m",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkmuej",
            "_1xi2idpf"
        ]),
        children: children
    });
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs1cd0 _syazwdcn _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l31gjq _irr316qz _9h8haqb7 _1di6fg4m",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)($1156f5d5007639c5$var$ShadowLeft, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($1156f5d5007639c5$export$924abd21043fc000, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
                color: "currentColor",
                spacing: "spacious",
                label: "left"
            })
        })
    });
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)($1156f5d5007639c5$export$a5ffe38c17bbc0a1, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($1156f5d5007639c5$export$abf07652016c7e56, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HvFx))), {
                color: "currentColor",
                spacing: "spacious",
                label: "right"
            })
        })
    });
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": dataTestId,
        className: (0, $35pXk.default)([
            "_2rko1l7b _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]),
        children: children
    });
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ]),
        children: children
    }));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
        ref: ref,
        style: style,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ]),
        children: children
    }));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $7UHDa.jsx)("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        children: children
    }, index);

});



parcelRegister("kSoKM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $095aa81eb4c35edf$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $095aa81eb4c35edf$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $095aa81eb4c35edf$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $095aa81eb4c35edf$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $2nPZH = parcelRequire("2nPZH");

var $aFUXX = parcelRequire("aFUXX");
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>(0, $3jLHL.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        transform: 'rotate(90deg)'
    }
});
const $095aa81eb4c35edf$export$a7ed6bf20867161a = (0, $3jLHL.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $gwFzn.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});

});


//# sourceMappingURL=modal.bda34e81.js.map
